module.exports = __webpack_public_path__ + "static/media/11.65be8561.jpg";